module.exports = __webpack_public_path__ + "static/media/main_section_bullet--blue.15b54f58.svg";